module.exports = __webpack_public_path__ + "img/portfolio-details3.d7ff684c.png";